(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["meraki-blog-hub"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.meraki-blog-hub').forEach(function(section){
    section.querySelectorAll('[data-topic]').forEach(function(button){
      button.addEventListener('click',function(){
        var topic=button.dataset.topic;
        section.querySelectorAll('[data-topic]').forEach(function(item){item.classList.toggle('is-active',item===button);item.setAttribute('aria-pressed',item===button?'true':'false')});
        section.querySelectorAll('[data-article]').forEach(function(card){var tags=(card.dataset.tags||'').split(',');card.hidden=topic!=='all'&&!tags.includes(topic)});
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meraki-blog-index"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.meraki-journal-index');

    sections.forEach((section) => {
      const categorySlider = section.querySelector('[data-category-slider]');
      const previousCategory = section.querySelector('[data-category-previous]');
      const nextCategory = section.querySelector('[data-category-next]');

      if (categorySlider && previousCategory && nextCategory) {
        const moveCategories = (direction) => {
          const firstCard = categorySlider.querySelector('.meraki-journal-category');
          if (!firstCard) return;
          const gap = Number.parseFloat(window.getComputedStyle(categorySlider).columnGap) || 0;
          categorySlider.scrollBy({ left: direction * (firstCard.getBoundingClientRect().width + gap), behavior: 'smooth' });
        };

        previousCategory.addEventListener('click', () => moveCategories(-1));
        nextCategory.addEventListener('click', () => moveCategories(1));
      }

      const articles = Array.from(section.querySelectorAll('[data-journal-article]'));
      const pagination = section.querySelector('[data-journal-pagination]');
      const pageSize = 12;
      const pageCount = Math.ceil(articles.length / pageSize);

      if (!pagination || pageCount <= 1) return;

      const getPage = () => {
        const page = Number(new URL(window.location.href).searchParams.get('journal_page')) || 1;
        return Math.min(Math.max(page, 1), pageCount);
      };

      const setPage = (page, updateUrl) => {
        const currentPage = Math.min(Math.max(page, 1), pageCount);
        const start = (currentPage - 1) * pageSize;

        articles.forEach((article, index) => {
          article.hidden = index < start || index >= start + pageSize;
        });

        pagination.replaceChildren();

        const addLink = (label, targetPage, isCurrent, ariaLabel) => {
          const element = document.createElement(isCurrent ? 'span' : 'a');
          element.textContent = label;
          element.className = isCurrent ? 'page current' : 'page';

          if (isCurrent) {
            element.setAttribute('aria-current', 'page');
          } else {
            const url = new URL(window.location.href);
            url.searchParams.set('journal_page', targetPage);
            element.href = `${url.pathname}${url.search}${url.hash}`;
            element.setAttribute('aria-label', ariaLabel);
            element.addEventListener('click', (event) => {
              event.preventDefault();
              setPage(targetPage, true);
            });
          }

          pagination.appendChild(element);
        };

        const addEllipsis = () => {
          const element = document.createElement('span');
          element.textContent = '…';
          element.className = 'page ellipsis';
          element.setAttribute('aria-hidden', 'true');
          pagination.appendChild(element);
        };

        const getPageList = () => {
          if (pageCount <= 7) {
            return Array.from({ length: pageCount }, (_, index) => index + 1);
          }
          const pages = [1];
          const start = Math.max(2, currentPage - 2);
          const end = Math.min(pageCount - 1, currentPage + 2);
          if (start > 2) pages.push('…');
          for (let page = start; page <= end; page += 1) pages.push(page);
          if (end < pageCount - 1) pages.push('…');
          pages.push(pageCount);
          return pages;
        };

        if (currentPage > 1) addLink('Previous', currentPage - 1, false, 'Previous articles page');
        getPageList().forEach((page) => {
          if (page === '…') addEllipsis();
          else addLink(String(page), page, page === currentPage, `Articles page ${page}`);
        });
        if (currentPage < pageCount) addLink('Next', currentPage + 1, false, 'Next articles page');

        pagination.hidden = false;

        if (updateUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('journal_page', currentPage);
          window.history.pushState({}, '', url);
          section.querySelector('.meraki-journal-latest')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      };

      setPage(getPage(), false);
      window.addEventListener('popstate', () => setPage(getPage(), false));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-compare"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    let resizeTimer = null;

    setTableBorder();
    
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        setTableBorder();
      }, 200);
    });
  });

  // 设置对比表格的高亮边框
  function setTableBorder() {
    const tableBoxNode = document.querySelector('.compare-section_content');
    if (tableBoxNode) {
      const tableNode = tableBoxNode.querySelector('.custom-table');
      if (tableNode) {
        const activeBorder = tableNode.querySelector('.item.active .active-border');
        const activeBorderBg = tableNode.querySelector('.item.active .active-border-bg');
        if (activeBorder && activeBorderBg) {
          const tableHeight = tableNode.offsetHeight + 0;
          activeBorder.style.height = `${tableHeight}px`;
          activeBorderBg.style.height = `${tableHeight - 6}px`;
        }
      }
    }
  }

  } catch(e) { console.error(e); }
})();
})();
